import { Injectable } from '@angular/core';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CreateRecordDialogComponent } from '../dialogs/records/create-record/create-record.dialog';
import { AlfrescoApiService } from '@alfresco/adf-core';
import { UdeuCreateRecord, UdeuEditMassiveRecord, UdeuRecord } from '../model/classes/udeu-record';
import { RecordActionTypes } from '../store/actions/record-actions';
import { CreateRecordGaudeDialogComponent } from '../dialogs/records/create-record-gaude/create-record-gaude.dialog';
import { ChooseOptionDialogComponent } from 'projects/alden-extension/src/lib/dialogs/choose-option/choose-option.dialog';
import { RecordTypes } from '../model/enums/record-types';
import { SelectionState } from '@alfresco/adf-extensions';
import { OrganizeTypes } from '../model/enums/organize-types';
import { OrganizeRecordDialogComponent } from '../dialogs/records/organize/organize-record.dialog';
import { SYS_NODE_UUID_PROP, UDEU_LOCATION_ASPECT, UDEU_LOCATION_DEPOSIT_PROP, UDEU_LOCATION_INSTALLATION_UNIT_PROP } from '../model/contants/deusto';
import { MinimalNodeEntity, NodePaging } from '@alfresco/js-api';
import { KeyValue } from '@angular/common';
import { Reorganize } from '../model/classes/reorganize';
import { Formacion } from '../model/classes/gaude-formacion';
import { Student } from '../model/classes/gaude-student';
import { CreateRecordFormacionDialogComponent } from '../dialogs/records/create-record-formacion/create-record-formacion.dialog';

@Injectable({
  providedIn: 'root'
})
export class RecordService {
  constructor(public dialog: MatDialog, private alfrescoApiService: AlfrescoApiService) { }

  openRecordDialogComponent(UUIDs: string[], recordActionType: RecordActionTypes, openedByUrl: boolean = false, selectedIndex?: number): MatDialogRef<CreateRecordDialogComponent> {
    return this.dialog.open(CreateRecordDialogComponent,
      {
        disableClose: true,
        autoFocus: true,
        width: '80%',
        maxHeight: '90%', 
        data:  { 
          UUIDs, 
          recordActionType, 
          openedByUrl,
          selectedIndex
        }
      },
    );
  }

  openCreateRecordDialogComponent(): void {
    const dialogRef = this.dialog.open(ChooseOptionDialogComponent,
      {
        disableClose: true,
        autoFocus: true,
        minWidth: '30%',
        maxWidth: '40%',
        maxHeight: '90%', 
        data: {
          title: "DEUSTO.ACTIONS.RECORD.TITLE",
          label: "ALDEN.DIALOGS.CHOOSE_OPTION.LABEL",
          options: [ 
            { key: RecordTypes.MANUAL, value: 'DEUSTO.ACTIONS.RECORD.MANUAL'}, 
            { key: RecordTypes.GAUDE, value: 'DEUSTO.ACTIONS.RECORD.GAUDE'},
            { key: RecordTypes.CONTINUOUS_FORMATION, value: 'DEUSTO.ACTIONS.RECORD.CONTINUOUS_FORMATION'}
          ],
          selectedOption: { key: RecordTypes.GAUDE, value: 'DEUSTO.ACTIONS.RECORD.GAUDE'}
        }
      },
    );

    dialogRef.afterClosed().subscribe((recordType: KeyValue<RecordTypes, string>) => {
      if (recordType !== null && recordType !== undefined) {
        const recordActionType = RecordActionTypes.CreateRecord;

        switch(recordType.key){
          case RecordTypes.MANUAL:
            this.dialog.open(CreateRecordDialogComponent,
              {
                disableClose: true,
                autoFocus: true,
                width: '80%',
                maxHeight: '90%', 
                data:  { recordActionType }
              },
            );
            break;
          case RecordTypes.GAUDE:
            const dialogGaude = this.dialog.open(CreateRecordGaudeDialogComponent,
              {
                disableClose: true,
                autoFocus: true,
                minWidth: '40%',
                maxWidth: '50%',
                maxHeight: '90%'
              },
            );
            //Cuando seleccione alumno y acepte, abrir la creación de registro
            dialogGaude.afterClosed().subscribe((student: Student) => {
              if(student.id_entidad){
                this.dialog.open(CreateRecordDialogComponent,
                  {
                    disableClose: true,
                    autoFocus: true,
                    width: '80%',
                    maxHeight: '90%', 
                    data:  { recordActionType, student }
                  },
                ); 
              }
            });
            break;
          case RecordTypes.CONTINUOUS_FORMATION:
            const dialogFormation = this.dialog.open(CreateRecordFormacionDialogComponent,
              {
                disableClose: true,
                autoFocus: true,
                minWidth: '40%',
                maxWidth: '50%',
                maxHeight: '90%'
              },
            );
            //Cuando seleccione alumno y acepte, abrir la creación de registro
            dialogFormation.afterClosed().subscribe((formacion: Formacion) => {
              if(formacion.idcurso){
                this.dialog.open(CreateRecordDialogComponent,
                  {
                    disableClose: true,
                    autoFocus: true,
                    width: '80%',
                    maxHeight: '90%', 
                    data:  { recordActionType, formacion }
                  },
                ); 
              }
            });
            break;
        }
      }
    });
  }

  openOrganizeRecordDialogComponent(_selection: SelectionState): void {
    const dialogRef = this.dialog.open(ChooseOptionDialogComponent,
      {
        disableClose: true,
        autoFocus: true,
        minWidth: '40%',
        maxWidth: '50%',
        maxHeight: '90%', 
        data: {
          title: "DEUSTO.ACTIONS.ORGANIZE.TITLE",
          label: "ALDEN.DIALOGS.CHOOSE_OPTION.LABEL",
          options: [ 
            { key: OrganizeTypes.REORGANIZE, value: 'DEUSTO.ACTIONS.ORGANIZE.REORGANIZE'}, 
            { key: OrganizeTypes.REORGANIZE_AND_MOVE, value: 'DEUSTO.ACTIONS.ORGANIZE.REORGANIZE_AND_MOVE'}
          ]
        }
      },
    );

    dialogRef.afterClosed().subscribe((organizeType: KeyValue<OrganizeTypes, string>) => {
      if (organizeType?.key >= 0) {
        this.dialog.open(OrganizeRecordDialogComponent,
          {
            disableClose: true,
            autoFocus: true,
            width: organizeType.key === OrganizeTypes.REORGANIZE_AND_MOVE ? '75%' : '50%',
            maxHeight: '90%', 
            data: organizeType
          },
        );
      }
    });
  }

  getRecordByUuid(recordUUID: string): Promise<NodePaging> {
    const path = 'search';
    const httpMethod = 'POST';
    const pathParams = {};
    const queryParams = {};
    const headerParams = {};
    const formParams = {};
    const bodyParam = {
      query: {
        language: "afts",
        query: `${SYS_NODE_UUID_PROP}:'${recordUUID}'`
      },
      include: [
          "properties"
      ]
    };
    const contentTypes = [];
    const accepts = [];
    const returnType = '';
    const url = 'alfresco/api/-default-/public/search/versions/1';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  getRecord(uuid: string): Promise<UdeuRecord> {
    const path = `smtecno/ssm/deusto/record/${uuid}`;
    const httpMethod = 'GET';
    const pathParams = {};  // No funciona
    const queryParams = {};
    const headerParams = {};
    const formParams = {};
    const bodyParam = {};
    const contentTypes = [];
    const accepts = [];
    const returnType = '';
    const url = 'alfresco/service';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  deleteRecords(items: MinimalNodeEntity[]): Promise<UdeuRecord> {
    const path = `smtecno/ssm/deusto/record`;
    const httpMethod = 'DELETE';
    const pathParams = {};  // No funciona
    const queryParams = {};
    const headerParams = {};
    const formParams = {};
    const bodyParam = { uuids: items.map((item) => item.entry.id) };
    const contentTypes = [];
    const accepts = [];
    const returnType = '';
    const url = 'alfresco/service';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  getUnidadInstalacionListByDeposit(depositId: string): Promise<NodePaging> {
      const path = 'search';
      const httpMethod = 'POST';
      const pathParams = {};
      const queryParams = {};
      const headerParams = {};
      const formParams = {};
      const bodyParam = {
        query: {
            query: `ASPECT:'${UDEU_LOCATION_ASPECT}' AND @${UDEU_LOCATION_DEPOSIT_PROP}:'${depositId}'`
        },
        include: [
            "allowableOperations",
            "aspectNames",
            "properties"
        ]
      };
      const contentTypes = [];
      const accepts = [];
      const returnType = '';
      const url = 'alfresco/api/-default-/public/search/versions/1';
  
      return this.alfrescoApiService
      .getInstance()
      .contentClient.callApi(
        path,
        httpMethod,
        pathParams,
        queryParams,
        headerParams,
        formParams,
        bodyParam,
        contentTypes,
        accepts,
        returnType,
        url
      );
  }

  getLocatedDocuments(depositId: string, installationUnit: string): Promise<NodePaging> {
    const path = 'search';
    const httpMethod = 'POST';
    const pathParams = {};
    const queryParams = {};
    const headerParams = {};
    const formParams = {};
    const bodyParam = {
      query: {
          query: `ASPECT:'${UDEU_LOCATION_ASPECT}' AND @${UDEU_LOCATION_DEPOSIT_PROP}:'${depositId}' AND @${UDEU_LOCATION_INSTALLATION_UNIT_PROP}:'${installationUnit}'`
      },
      include: [
          "allowableOperations",
          "aspectNames",
          "properties",
          "path"
      ],
      sort: [
        {
          type: "FIELD",
          field: "udeu:locationDocument",
          ascending: true
        }
      ]
    };
    const contentTypes = [];
    const accepts = [];
    const returnType = '';
    const url = 'alfresco/api/-default-/public/search/versions/1';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  getAuthorByUuid(authorUUID: string): Promise<NodePaging> {
    const path = 'search';
    const httpMethod = 'POST';
    const pathParams = {};
    const queryParams = {};
    const headerParams = {};
    const formParams = {};
    const bodyParam = {
      query: {
        language: "afts",
        query: `${SYS_NODE_UUID_PROP}:'${authorUUID}'`
      },
      include: [
          "properties"
      ]
    };
    const contentTypes = [];
    const accepts = [];
    const returnType = '';
    const url = 'alfresco/api/-default-/public/search/versions/1';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  getLocationByUuid(locationUUID: string): Promise<NodePaging> {
    const path = 'search';
    const httpMethod = 'POST';
    const pathParams = {};
    const queryParams = {};
    const headerParams = {};
    const formParams = {};
    const bodyParam = {
      query: {
        language: "afts",
        query: `${SYS_NODE_UUID_PROP}:'${locationUUID}'`
      },
      include: [
          "properties"
      ]
    };
    const contentTypes = [];
    const accepts = [];
    const returnType = '';
    const url = 'alfresco/api/-default-/public/search/versions/1';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  createRecord(udeuCreateRecord: UdeuCreateRecord, draft = false) : Promise<string> {
    const formParam: any = {
      data: JSON.stringify(udeuCreateRecord.data)
    };

    udeuCreateRecord.files?.forEach((file) => { 
      const fileId = file.id;
      formParam[fileId] = file.file;
    });

    const path = 'smtecno/ssm/deusto/record';
    const httpMethod = 'POST';
    const pathParams = {};
    const queryParams = { draft };
    const headerParams = {};
    const formParams = formParam;
    const bodyParam = {};
    const contentTypes = ['multipart/form-data'];
    const accepts = ['text/plain'];
    const returnType = '';
    const url = 'alfresco/service';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  createUpdateRecord(uuid: string, udeuCreateRecord: UdeuCreateRecord, draft = false, duplicate = false) : Promise<void> {
    const formParam: any = {
      data: JSON.stringify(udeuCreateRecord.data)
    };

    udeuCreateRecord.files?.forEach((file) => { 
      const fileId = file.id;
      formParam[fileId] = file.file;
    });

    const path = `smtecno/ssm/deusto/record/${uuid}`;
    const httpMethod = 'POST';
    const pathParams = {};
    const queryParams = { draft, duplicate };
    const headerParams = {};
    const formParams = formParam;
    const bodyParam = {};
    const contentTypes = ['multipart/form-data'];
    const accepts = ['text/plain'];
    const returnType = '';
    const url = 'alfresco/service';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  updateRecord(uuid: string, udeuCreateRecord: UdeuCreateRecord) : Promise<void> {
    const formParam: any = {
      data: JSON.stringify(udeuCreateRecord.data)
    };

    udeuCreateRecord.files?.forEach((file) => { 
      const fileId = file.id;
      formParam[fileId] = file.file;
    });

    const path = `smtecno/ssm/deusto/record/${uuid}`;
    const httpMethod = 'PUT';
    const pathParams = {};  // No funciona
    const queryParams = {};
    const headerParams = {};
    const formParams = formParam;
    const bodyParam = {};
    const contentTypes = ['multipart/form-data'];
    const accepts = ['text/plain'];
    const returnType = '';
    const url = 'alfresco/service';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  reorganizeDocuments(reorganize: Reorganize): Promise<any> {
    const path = 'smtecno/ssm/deusto/record/reorganize';
    const httpMethod = 'POST';
    const pathParams = {};
    const queryParams = {};
    const headerParams = {};
    const formParams = {};
    const bodyParam = reorganize;
    const contentTypes = ['application/json'];
    const accepts = [];
    const returnType = '';
    const url = 'alfresco/service';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  getMassiveRecords(uuids: string[]): Promise<UdeuRecord> {
    const path = 'smtecno/ssm/deusto/record/bulk';
    const httpMethod = 'POST';
    const pathParams = {};
    const queryParams = {};
    const headerParams = {};
    const formParams = {};
    const bodyParam = { uuids };
    const contentTypes = ['application/json'];
    const accepts = [];
    const returnType = '';
    const url = 'alfresco/service';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  editMassiveRecords(udeuEditMassiveRecord: UdeuEditMassiveRecord): Promise<any> {
    const path = 'smtecno/ssm/deusto/record/bulk';
    const httpMethod = 'PUT';
    const pathParams = {};
    const queryParams = {};
    const headerParams = {};
    const formParams = {};
    const bodyParam = udeuEditMassiveRecord;
    const contentTypes = ['application/json'];
    const accepts = ['text/plain'];
    const returnType = '';
    const url = 'alfresco/service';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

}
